import { render, staticRenderFns } from "./SecuritySystem.vue?vue&type=template&id=620c71fa&scoped=true&"
import script from "./SecuritySystem.vue?vue&type=script&lang=js&"
export * from "./SecuritySystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c71fa",
  null
  
)

export default component.exports